import React from 'react'
import MiniLayout from '../components/MiniLayout'

const AdminEmployee = () => {
  return (
    <>
    <MiniLayout>
        <div className="adminEmployee">
            <span><img src="/assets/image/aframe.png" alt="" /></span>
            <h5>Скоро здесь вы сможете добавлять Ваших сотрудников.</h5>
        </div>
    </MiniLayout>
    </>
  )
}

export default AdminEmployee